/* KG Book Modal: opens the Dubsado discovery-call scheduler in a popup.
   Triggers: links to #book or /#book, links or buttons with data-kg-book, links whose text says "Book a call" or "Book a discovery call", or the URL hash #book-call. */
(function () {
  var SCHEDULER = 'https://hello.dubsado.com/public/appointment-scheduler/614bab0bb173eaa1e1f94521/schedule?isIframe=true';
  var RESIZER = 'https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/3.5.14/iframeResizer.min.js';
  var modal = null, panel = null, closeBtn = null, frameWrap = null, lastFocus = null, frameBuilt = false;

  var CSS = [
    '.kg-bookmodal{position:fixed;inset:0;z-index:99999;display:none;align-items:center;justify-content:center;padding:24px;background:rgba(6,52,47,.72)}',
    '.kg-bookmodal.is-open{display:flex}',
    '.kg-bookmodal__panel{position:relative;width:100%;max-width:880px;max-height:92vh;display:flex;flex-direction:column;background:#e8f8c6;color:#06342f;border:1.5px solid #06342f;border-radius:26px;box-shadow:0 30px 80px rgba(6,52,47,.35);overflow:hidden}',
    '.kg-bookmodal__head{display:flex;align-items:flex-start;justify-content:space-between;gap:16px;padding:26px 30px 18px;border-bottom:1.5px solid rgba(6,52,47,.16)}',
    '.kg-bookmodal__label{font-size:12.5px;font-weight:600;letter-spacing:.1em;text-transform:uppercase;color:#587065;margin:0 0 6px}',
    '.kg-bookmodal__title{font-size:clamp(26px,3.4vw,38px);line-height:1.05;letter-spacing:-.02em;font-weight:800;margin:0}',
    '.kg-bookmodal__sub{font-size:15px;line-height:1.45;color:#3f5a52;margin:8px 0 0;max-width:46ch}',
    '.kg-bookmodal__close{flex:none;width:44px;height:44px;border-radius:50%;border:1.5px solid #06342f;background:#fff;color:#06342f;font-size:22px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center}',
    '.kg-bookmodal__close:hover,.kg-bookmodal__close:focus-visible{background:#06342f;color:#e8f8c6}',
    '.kg-bookmodal__body{position:relative;flex:1;overflow-y:auto;background:#fff;-webkit-overflow-scrolling:touch;min-height:320px}',
    '.kg-bookmodal__loading{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-size:15px;color:#587065}',
    '.kg-bookmodal__body iframe{display:block;width:1px;min-width:100%;border:0;overflow:hidden;min-height:640px;position:relative;z-index:1}',
    'body.kg-bookmodal-lock{overflow:hidden}',
    '@media (max-width:749px){.kg-bookmodal{padding:0;align-items:stretch}.kg-bookmodal__panel{max-height:none;height:100%;border-radius:0;border-width:0}.kg-bookmodal__head{padding:20px 18px 14px}}'
  ].join('');

  function addStyles() {
    if (document.getElementById('kg-bookmodal-css')) return;
    var s = document.createElement('style');
    s.id = 'kg-bookmodal-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function build() {
    if (modal) return;
    addStyles();
    modal = document.createElement('div');
    modal.className = 'kg-bookmodal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'kg-bookmodal-title');
    modal.innerHTML = [
      '<div class="kg-bookmodal__panel" tabindex="-1">',
      '<div class="kg-bookmodal__head"><div>',
      '<p class="kg-bookmodal__label">Start a project</p>',
      '<h2 class="kg-bookmodal__title" id="kg-bookmodal-title">Book a discovery call</h2>',
      '<p class="kg-bookmodal__sub">30 minutes, no pressure. Pick a time and we will look at your store together.</p>',
      '</div><button type="button" class="kg-bookmodal__close" aria-label="Close booking form">&times;</button></div>',
      '<div class="kg-bookmodal__body"><div class="kg-bookmodal__loading">Loading calendar...</div></div>',
      '</div>'
    ].join('');
    document.body.appendChild(modal);
    panel = modal.querySelector('.kg-bookmodal__panel');
    closeBtn = modal.querySelector('.kg-bookmodal__close');
    frameWrap = modal.querySelector('.kg-bookmodal__body');
    closeBtn.addEventListener('click', close);
    modal.addEventListener('mousedown', function (e) { if (e.target === modal) close(); });
  }

  function buildFrame() {
    if (frameBuilt) return;
    frameBuilt = true;
    var f = document.createElement('iframe');
    f.id = 'kg-book-iframe';
    f.src = SCHEDULER;
    f.title = 'Book a discovery call';
    f.setAttribute('frameborder', '0');
    f.setAttribute('scrolling', 'no');
    f.addEventListener('load', function () {
      var l = frameWrap.querySelector('.kg-bookmodal__loading');
      if (l) l.remove();
    });
    frameWrap.appendChild(f);
    var sc = document.createElement('script');
    sc.src = RESIZER;
    sc.onload = function () {
      if (window.iFrameResize) window.iFrameResize({ checkOrigin: false, heightCalculationMethod: 'taggedElement' }, '#kg-book-iframe');
    };
    sc.onerror = function () { f.style.height = '760px'; f.setAttribute('scrolling', 'auto'); };
    document.body.appendChild(sc);
  }

  function open() {
    build();
    lastFocus = document.activeElement;
    modal.classList.add('is-open');
    document.body.classList.add('kg-bookmodal-lock');
    buildFrame();
    setTimeout(function () { closeBtn.focus(); }, 30);
    document.addEventListener('keydown', onKey, true);
  }

  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.classList.remove('kg-bookmodal-lock');
    document.removeEventListener('keydown', onKey, true);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    if (location.hash === '#book-call') history.replaceState(null, '', location.pathname + location.search);
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = panel.querySelectorAll('button,[href],iframe,[tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function isTrigger(el) {
    if (el.hasAttribute('data-kg-book')) return true;
    var href = el.getAttribute('href');
    if (el.tagName !== 'A') return false;
    if (href === null) return false;
    if (/^(mailto:|tel:)/i.test(href)) return false;
    if (href === '#book' || href === '/#book' || href === '#book-call') return true;
    var u;
    try { u = new URL(href, location.origin); } catch (e) { return false; }
    if (u.origin !== location.origin) return false;
    if ((u.hash === '#book' || u.hash === '#book-call') && (u.pathname === '/' || u.pathname === location.pathname)) return true;
    return /\bbook an? (discovery |intro )?call\b/i.test(el.textContent || '');
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var el = e.target.closest && e.target.closest('a,button');
    if (!el || !isTrigger(el)) return;
    e.preventDefault();
    open();
  });

  if (location.hash === '#book-call') window.addEventListener('load', open);
})();
